"use strict";

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _lodash = require("lodash");

var _lodash2 = _interopRequireDefault(_lodash);

var _debug = require("debug");

var _debug2 = _interopRequireDefault(_debug);

var _device = require("../device");

var _device2 = _interopRequireDefault(_device);

var _util = require("../util");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var NanoKONTROL2 = function (_Device) {
  _inherits(NanoKONTROL2, _Device);

  _createClass(NanoKONTROL2, null, [{
    key: "detect",
    value: function detect(name) {
      return (/^nanoKONTROL2\s/i.test(name)
      );
    }
  }, {
    key: "deviceName",
    get: function get() {
      return "nanoKONTROL2";
    }
  }]);

  function NanoKONTROL2(input, name) {
    _classCallCheck(this, NanoKONTROL2);

    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(NanoKONTROL2).call(this, input, name));

    _this.debug = (0, _debug2.default)("korg-nano-kontrol:nanoKONTROL2");
    _this.debug("created");

    (0, _util.eachWithIndex)(_lodash2.default.range(0, 8), function (index, code) {
      _this.slider(code, index);
    });

    (0, _util.eachWithIndex)(_lodash2.default.range(16, 24), function (index, code) {
      _this.knob(code, index);
    });

    (0, _util.eachWithIndex)(_lodash2.default.range(32, 40), function (index, code) {
      _this.button(code, "s:" + index);
    });

    (0, _util.eachWithIndex)(_lodash2.default.range(48, 56), function (index, code) {
      _this.button(code, "m:" + index);
    });

    (0, _util.eachWithIndex)(_lodash2.default.range(64, 72), function (index, code) {
      _this.button(code, "r:" + index);
    });

    _this.button(41, "play");
    _this.button(42, "stop");
    _this.button(43, "prev");
    _this.button(44, "next");
    _this.button(45, "rec");
    _this.button(46, "cycle");
    _this.button(60, "marker:set");
    _this.button(61, "marker:prev");
    _this.button(62, "marker:next");
    _this.button(58, "track:prev");
    _this.button(59, "track:next");
    return _this;
  }

  return NanoKONTROL2;
}(_device2.default);

exports.default = NanoKONTROL2;
//# sourceMappingURL=data:application/json;base64,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


/*****************
 ** WEBPACK FOOTER
 ** ./~/korg-nano-kontrol/lib/devices/nanoKONTROL2.js
 ** module id = 16
 ** module chunks = 2
 **/